import React, { useEffect, useRef, useState } from "react";
// import './Lottery.css'
import initCanvas from "../canvas/index";
import audiImg from "../img/fix_audi.png";
import mclarenImg from "../img/fix_mclaren.png";
import mercedesImg from "../img/fix_mercedes.png";
import watchImg from "../img/congrat_watch.png";
import goldImg from "../img/fix_gold.png";
import iphoneImg from "../img/congrat_iphone.png";
import cash500Img from "../img/fix_cash500.png";
import cash30Img from "../img/fix_cash30.png";
import cash100Img from "../img/fix_cash100.png";
import cash50Img from "../img/fix_cash50.png";
import { sideMenu } from "../Service";
import { handleAccount } from "../getCreateAccLink";
import "whatwg-fetch";
import { FAN_RADIAN } from "../canvas/dimension";
import { LANG } from "../LangConfig";
import Congrat from "./Congrat";
import ErrorMessage from "./ErrorMessage";
import MakeDeposit from "./MakeDeposit";
import ConnectFinlogixPop from "./ConnectFinlogixPop";

const lang = LANG === "zh" ? "zh" : "en";

const spinPrizeTableContent = [
  { deposit: "USD $2,000", prize: "USD $30" },
  { deposit: "AUD A$2,000", prize: "USD $30" },
  { deposit: "EUR €2,000", prize: "USD $30" },
  { deposit: "GBP £1,500", prize: "USD $30" },
  { deposit: "NZD NZ$3,000", prize: "USD $30" },
  { deposit: "CAD CA$2,500", prize: "USD $30" },
  { deposit: "JPY ¥300,000", prize: "USD $30" },
];
const giftIdConfig = {
  31: [8, cash30Img, "cash30"],
  32: [4, cash50Img, "cash50"],
  33: [10, cash100Img, "cash100"],
  34: [6, cash500Img, "cash500"],
  35: [2, iphoneImg, "iphone"],
  36: [9, watchImg, "watch"],
  37: [5, goldImg, "gold"],
  38: [3, mercedesImg, "mercedes"],
  39: [7, audiImg, "audi"],
  40: [1, mclarenImg, "mclaren"],
};

//test url
// const acyUrl = 'https://acyltd-api-cloudhub-dev.zeroclouddev.com'
// const synergyUrl = 'https://acyau-api-cloudhub-dev.zeroclouddev.com'
// const connectStateUrl = 'http://g1api.finlogixtesting.com/v1/app-service/connect-status';
// const finlogixUrl = 'http://www.finlogixtest.com'
//online url
const acyUrl = "https://api.acyfx.com/v1/";
const synergyUrl = "https://api_admin.synergyfx.com/v1/";
const connectStateUrl =
  "https://g1api.finlogix.com/v1/app-service/connect-status";
const finlogixUrl = "https://connect.finlogix.com";

const getHostUrl = (currentUrl) => {
  let host = null;
  switch (currentUrl.toLowerCase()) {
    case "acy":
      host = acyUrl;
      break;
    case "sng":
      host = synergyUrl;
      break;
    case "synergy":
      host = synergyUrl;
      break;
  }

  return host;
};

const draw = (baseUrl, token) => {
  return fetch(`${baseUrl}lottery/run`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
      language: lang,
    },
  }).then((response) => response.json());
};
const getCount = (baseUrl, token) => {
  return fetch(`${baseUrl}lottery/getLeftLucky`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
      language: lang,
    },
  }).then((response) => response.json());
};

const verifyFinlogixConnection = (url, token) => {
  return fetch(connectStateUrl, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
      language: lang,
    },
    body: JSON.stringify({
      app_token: token,
      api_key: url === "SNG" ? "synergy" : url,
    }),
  }).then((response) => response.json());
};

const Lottery = ({ text, lang }) => {
  const [lotteryToken, setLotterToken] = useState(null);
  const [prizeId, setPrizeId] = useState("");
  const [prizeName, setPrizeName] = useState("");
  const [chanceCount, setChanceCount] = useState(null);
  const [isRunning, setCanvasAnimationState] = useState(false);
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [congratShow, setCongratShow] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [showDepositPop, setShowDepositPop] = useState(false);
  const [showConnectPop, setShowConnectPop] = useState(false);
  const [connected, setConnected] = useState(null);
  const [isLoggedIn, setLoginState] = useState(false);
  const [mouseInCenter, setMouseInCenter] = useState(false);
  const canvas = useRef(null);

  const getCloudhubOption = (regulation) =>
    regulation === "asic" ? "SNG" : "acy";

  const handleToken = (token, isSaveToken) => {
    if (isSaveToken) {
      setLotterToken(token);
      localStorage.setItem("lottery_token", token);
    } else {
      setLotterToken("");
      localStorage.removeItem("lottery_token", "");
    }
  };

  const handleLoginButtonClick = () => {
    const loginButton = document.querySelector("#login-cmp-form button");
    loginButton.click();
  };

  useEffect(() => {
    initCanvas(canvas.current);
  }, []);

  // useEffect(() => {
  //     new window.AcyForm.FormLoginCmp({
  //         documentID: document.getElementById('login-cmp-form'),
  //         content: 'Login',
  //         lang: lang,
  //         disabled: false,
  //         // isDev: true,
  //         loginSuccessCallback: ({
  //             userInfo,
  //             token
  //         }) => {
  //             const cloudhubOption = getCloudhubOption(userInfo.regulation);
  //             document.getElementById('spin-wheel').scrollIntoView();
  //             localStorage.setItem('url', cloudhubOption);
  //             handleToken(token, true)
  //         }
  //     })
  // }, [])

  useEffect(() => {
    const token = lotteryToken || localStorage.getItem("lottery_token");
    const url = localStorage.getItem("url");
    const baseUrl = url && getHostUrl(url);

    if (token) {
      verifyFinlogixConnection(url, token).then((response) => {
        /*token expire or user not found*/
        if (
          response.code === 1062003 ||
          response.code === 1062002 ||
          response.code === 1062001
        ) {
          clearToken();
          return;
        }

        setLoginState(true);

        if (!response.connected) {
          setShowConnectPop(true);
          setConnected(false);
        } else {
          setConnected(true);
        }

        if (baseUrl) {
          setChanceCount(response.count);
          setName(response.name);
          localStorage.setItem("username", response.name);
          getCount(baseUrl, token).then((response) => {
            setChanceCount(response.count);
            setName(response.name);
            localStorage.setItem("username", response.name);
          });
        }
      });
    }
  }, [lotteryToken]);

  // const clearToken = () => {
  //     handleToken('', false)
  //     handleLoginButtonClick();
  //     setLoginState(false)
  //     setName('')
  //     setChanceCount(null)
  // };

  const clearToken = () => {
    localStorage.clear();
    setLoginState(false);
    setName("");
    setChanceCount(null);
  };

  const closeCongrat = () => {
    setCongratShow(false);
    initCanvas(canvas.current);
  };

  const popUpAction = {
    connect: setShowConnectPop,
    error: setShowErrorMessage,
    deposit: setShowDepositPop,
  };

  const closePop = (popType) => {
    popUpAction[popType](false);
  };

  const connectFinlogix = () => {
    const token = localStorage.getItem("lottery_token");
    const key = localStorage.getItem("url");
    let api_key = key === "SNG" ? "synergy" : key;
    window.location.href = `${finlogixUrl}?api_key=${api_key}&app_token=${token}&callback=${window.location.href}#spin-wheel`;
  };

  // const runLottery = (e) => {

  //     if (!mouseInCenter) {
  //         return;
  //     }

  //     const token = localStorage.getItem('lottery_token');
  //     const url = localStorage.getItem('url');

  //     if (!token) {
  //         handleLoginButtonClick();
  //         return;
  //     }

  //     const baseUrl = getHostUrl(localStorage.getItem('url'));

  //     verifyFinlogixConnection(url, token).then(
  //         (response) => {
  //             /*token problems*/
  //             if (response.code === 1062003) {
  //                 clearToken();
  //                 setMessage(response.message);
  //                 setShowErrorMessage(true);
  //                 setTimeout(()=>{window.location.reload(); }, 3000);
  //                 return
  //             }

  //             if (response.code === 1062002 || response.code === 1062001) {
  //                 clearToken();
  //                 setMessage(response.message);
  //                 setShowErrorMessage(true)
  //                 return
  //             }

  //             setLoginState(true)

  //             if (!response.connected) {
  //                 setShowConnectPop(true)

  //             } else {
  //                 setConnected(true)
  //                 draw(baseUrl, token).then((response) => {
  //                     if (response.status === 200) {

  //                         const id = response.info.prizeid;
  //                         setPrizeId(id);

  //                         const prizeNameKey = giftIdConfig[id][2];
  //                         const prizeNameObj = text.prize_name;
  //                         setPrizeName(prizeNameObj[prizeNameKey]);

  //                         const offset = giftIdConfig[id] && giftIdConfig[id][0];

  //                         if (!isRunning) {

  //                             setCanvasAnimationState(true);
  //                             initCanvas(canvas.current, true, 7 * 2 * Math.PI + offset * FAN_RADIAN, () => {
  //                                 setCanvasAnimationState(false);
  //                                 setTimeout(function () {
  //                                     setCongratShow(true);
  //                                 }, 1500);

  //                                 getCount(baseUrl, token).then(
  //                                     (response) => {
  //                                         setChanceCount(response.count);

  //                                     }
  //                                 );

  //                             })
  //                         }

  //                     } else {

  //                         if (response.status_code === 401) {
  //                             clearToken();
  //                             return
  //                         }

  //                         if (response.status_code === 500) {

  //                             setMessage('server error');
  //                             setShowErrorMessage(true);
  //                             return
  //                         }

  //                         if (response.status === -100) {
  //                             const string=response.info;
  //                             const resArray=string.match(/\d+/g).map(Number) ;
  //                             setMessage(`${text.not_start} ${resArray[2]}/${resArray[1]}/${resArray[0]} 00:00 ${text.please_wait}`);
  //                             setShowErrorMessage(true)
  //                             return
  //                         }

  //                         if (response.status_code === 429) {

  //                             setMessage(text.error_messages[response.status_code]);
  //                             setShowErrorMessage(true)

  //                         } else if (response.status === -104) {

  //                             setShowDepositPop(true)

  //                         } else {

  //                             setMessage(text.error_messages[response.status]);
  //                             setShowErrorMessage(true)
  //                         }
  //                     }
  //                 })
  //             }
  //         })
  //         .catch(err=>{
  //             setMessage('network error');
  //             setShowErrorMessage(true)
  //         })
  // };

  const runLottery = (e) => {
    if (!mouseInCenter) {
      return;
    }

    const token = localStorage.getItem("lottery_token");
    const url = localStorage.getItem("url");

    if (!token) {
      // sideMenu.openNav(window.LotterySideMenu.State.CLOUDHUB_LOGIN);
      sideMenu.openSelectedForm("login");
      return;
    }

    const baseUrl = getHostUrl(localStorage.getItem("url"));

    verifyFinlogixConnection(url, token)
      .then((response) => {
        /*token problems*/
        if (response.code === 1062003) {
          clearToken();
          setMessage(response.message);
          setShowErrorMessage(true);
          setTimeout(() => {
            window.location.reload();
          }, 3000);
          return;
        }

        if (response.code === 1062002 || response.code === 1062001) {
          clearToken();
          setMessage(response.message);
          setShowErrorMessage(true);
          return;
        }

        setLoginState(true);

        if (!response.connected) {
          setShowConnectPop(true);
        } else {
          setConnected(true);
          draw(baseUrl, token).then((response) => {
            if (response.status === 200) {
              const id = response.info.prizeid;
              setPrizeId(id);

              const prizeNameKey = giftIdConfig[id][2];
              const prizeNameObj = text.prize_name;
              setPrizeName(prizeNameObj[prizeNameKey]);

              const offset = giftIdConfig[id] && giftIdConfig[id][0];

              if (!isRunning) {
                setCanvasAnimationState(true);
                initCanvas(
                  canvas.current,
                  true,
                  7 * 2 * Math.PI + offset * FAN_RADIAN,
                  () => {
                    setCanvasAnimationState(false);
                    setTimeout(function () {
                      setCongratShow(true);
                    }, 1500);

                    getCount(baseUrl, token).then((response) => {
                      setChanceCount(response.count);
                    });
                  },
                );
              }
            } else {
              if (response.status_code === 401) {
                // sideMenu.openNav(window.LotterySideMenu.State.CLOUDHUB_LOGIN);
                sideMenu.openSelectedForm("login");
                clearToken();
                return;
              }

              if (response.status_code === 500) {
                setMessage("server error");
                setShowErrorMessage(true);
                return;
              }

              if (response.status === -100) {
                const string = response.info;
                const resArray = string.match(/\d+/g).map(Number);
                setMessage(
                  `${text.not_start} ${resArray[2]}/${resArray[1]}/${resArray[0]} 00:00 ${text.please_wait}`,
                );
                setShowErrorMessage(true);
                return;
              }

              if (response.status_code === 429) {
                setMessage(text.error_messages[response.status_code]);
                setShowErrorMessage(true);
              } else if (response.status === -104) {
                setShowDepositPop(true);
              } else {
                setMessage(text.error_messages[response.status]);
                setShowErrorMessage(true);
              }
            }
          });
        }
      })
      .catch((err) => {
        setMessage("network error");
        setShowErrorMessage(true);
      });
  };

  const isMouseInCenter = (e) => {
    const { clientX, clientY } = e;
    const { top, left, height, width } = canvas.current.getBoundingClientRect();
    const centerTop = top + height / 2 - height / 17;
    const centerBottom = top + height / 2 + height / 17;
    const centerLeft = left + width / 2 - width / 25;
    const centerRight = left + width / 2 + width / 25;

    if (
      clientX > centerLeft &&
      clientX < centerRight &&
      clientY < centerBottom &&
      clientY > centerTop
    ) {
      return true;
    }

    return false;
  };

  const checkMouse = (e) => {
    /*add hover effect for spin button*/
    if (isRunning) {
      return;
    }

    if (mouseInCenter !== isMouseInCenter(e)) {
      setMouseInCenter(!mouseInCenter);
      initCanvas(canvas.current, false, 0, () => {}, !mouseInCenter);
    }
  };

  return (
    <div className="lottery-bg">
      <div id="spin-wheel" className="lottery-wrapper">
        <div id="above-lottery" className="above-lottery">
          <div className={!isLoggedIn ? "stage-0" : "hide"}>
            <h2>{text.title}</h2>
            <div className="description-wrapper">
              {text.descriptions.map((text) => (
                <p
                  dangerouslySetInnerHTML={{ __html: text }}
                  className="description"
                />
              ))}
            </div>

            <table className="deposit-prize-table-container">
              <tr>
                <th>{text.spin_min_deposite}</th>
                {/* <th>{text.spin_prize}</th> */}
              </tr>
              {spinPrizeTableContent.map((item) => (
                <tr key={item.deposit}>
                  <td>{item.deposit}</td>
                  {/* <td>{item.prize}</td> */}
                </tr>
              ))}
              <tr></tr>
            </table>
            {/* <div className={`spin-content-container ${lang === 'ar' ? 'ar-container': ''}`}>
                            <h1>{text.special_promo_title}</h1>
                            {
                                text.special_promo_content.slice(0,5).map((item) => 
                                <div key={item} className='spin-content-item'>
                                    <span className="dot" />
                                    <span dangerouslySetInnerHTML={{__html:item}} />
                                </div>)
                            }
                        </div> */}
            {/* <div className="buttons">
                            <button className={`open-btn ${lang}`}
                                onClick={handleAccount(lang)}>{text.openAccount}</button>
                            <div id="login-cmp-form"/>
                        </div> */}
            <div className="buttons">
              <button
                className={`open-btn ${lang}`}
                onClick={handleAccount(lang)}
              >
                {text.openAccount}
              </button>
              <button
                className="login-btn"
                onClick={() => sideMenu.openSelectedForm("login")}
              >
                {text.login}
              </button>
            </div>
          </div>

          <div className={!connected && isLoggedIn ? "stage-connect" : "hide"}>
            <h2>{text.title}</h2>
            <p>{text.connect} </p>
            {/* <div className="buttons">
                            <button className="connect-btn" onClick={() => connectFinlogix()}>{text.connect_btn}</button>
                            <button className="logout-btn" onClick={() =>  clearToken()}>{text.logout}</button>   
                        </div> */}
            <div className="buttons">
              <button className="connect-btn" onClick={() => connectFinlogix()}>
                {text.connect_btn}
              </button>
              <button className="logout-btn" onClick={() => clearToken()}>
                {text.logout}
              </button>
            </div>
          </div>

          <div className={connected && isLoggedIn ? "stage-spin" : "hide"}>
            <h2>{text.title}</h2>
            <p className="small-margin">
              <span>{text.click_btn}</span>
            </p>
            <p>
              <span>{text.you_have}</span>
              <span className="chance-count"> {chanceCount} </span>
              <span>
                {chanceCount > 1
                  ? text.chances && text.chances
                  : text.chance && text.chance}
              </span>
              <span> {text.left}</span>
            </p>
            <button className="logout-btn" onClick={() => clearToken()}>
              {text.logout}
            </button>
          </div>

          <div id="download-term" className="terms">
            <p dangerouslySetInnerHTML={{ __html: text.terms }} />
          </div>
        </div>

        <div className="canvas-wrapper">
          <div
            ref={canvas}
            onClick={(e) => runLottery(e)}
            onMouseMove={(e) => checkMouse(e)}
            className={mouseInCenter ? "has-pointer" : null}
          />
        </div>
      </div>

      <Congrat
        text={text.congratulations_pop}
        prizeName={prizeName}
        src={giftIdConfig[prizeId] ? giftIdConfig[prizeId][1] : null}
        show={congratShow}
        closeModal={closeCongrat}
        lang={LANG}
      />
      <ErrorMessage
        message={message}
        show={showErrorMessage}
        closePop={closePop}
        lang={LANG}
      />
      <MakeDeposit
        text={text.deposit_pop}
        show={showDepositPop}
        closePop={closePop}
        url={localStorage.getItem("url")}
        lang={LANG}
      />
      <ConnectFinlogixPop
        text={text.connect_finlogix_pop}
        show={showConnectPop}
        closePop={closePop}
        connectFinlogix={connectFinlogix}
        lang={LANG}
      />
    </div>
  );
};

//<Congrat text={text.congratulations_pop} prizeName={ 'cash 100' } src={cash30}  show={ true } />

export default Lottery;
